import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import { UtmMetricsClassifiedResponse, UtmDailyResponse, UtmDailyAffiliateData, UtmBettorsResponse } from '../interfaces/utm';
import { ApiResponse } from '../interfaces/application';

@Injectable({
  providedIn: 'root'
})
export class UtmMetricsService {
  private apiUrl = environment.api;

  constructor(private http: HttpClient) {}

  queryClassified(params: {
    brand?: string;
    start_date: string;
    end_date: string;
    segmento_id?: string;
    utm_source?: string
  }): Observable<UtmMetricsClassifiedResponse> {
    let httpParams = new HttpParams()
      .set('start_date', params.start_date)
      .set('end_date', params.end_date);

    if (params.brand) {
      httpParams = httpParams.set('brand', params.brand);
    }

    if (params.segmento_id) {
      httpParams = httpParams.set('segmento_id', params.segmento_id);
    }

    if (params.utm_source) {
      httpParams = httpParams.set('utm_source', params.utm_source);
    }

    return this.http.get<UtmMetricsClassifiedResponse>(
      `${this.apiUrl}/utm/metrics`,
      { params: httpParams }
    );
  }

  queryDaily(params: {
    utm_afiliados_id: string;
    start_date: string;
    end_date: string;
    segmento_id: string;
  }): Observable<any> {
    const httpParams = new HttpParams()
      .set('utm_afiliados_id', params.utm_afiliados_id)
      .set('start_date', params.start_date)
      .set('end_date', params.end_date)
      .set('segmento_id', params.segmento_id);

    return this.http.get<any>(
      `${this.apiUrl}/utm/metrics-agent-view/daily`,
      { params: httpParams }
    );
  }

  queryBettors(params: {
    start_date: string;
    end_date: string;
    user_id?: string;
    page?: number;
    per_page?: number;
  }): Observable<UtmBettorsResponse> {
    let httpParams = new HttpParams()
      .set('start_date', params.start_date)
      .set('end_date', params.end_date);

    if (params.user_id) {
      httpParams = httpParams.set('user_id', params.user_id);
    }

    if (params.page) {
      httpParams = httpParams.set('page', String(params.page));
    }

    if (params.per_page) {
      httpParams = httpParams.set('per_page', String(params.per_page));
    }

    return this.http.get<UtmBettorsResponse>(
      `${this.apiUrl}/utm/query-bettors`,
      { params: httpParams }
    );
  }
}
